import React from "react";

import CardColumn from "components/CardColumn";

interface Props {
	viewLabel: string;
	handleRadioClick: (id: string) => void;
	isChecked: boolean;
	id: string;
	description?: string;
}

function ViewCard({
	id,
	viewLabel,
	handleRadioClick,
	isChecked,
	description,
}: Props) {
	return (
		<>
			<CardColumn width="none" className="view-modal-card__radio">
				<div className="view-radio custom-radio">
					<input
						id={id}
						className="form-check-input"
						type="radio"
						onChange={() => {
							handleRadioClick(id);
						}}
						value={id}
						checked={isChecked}
					/>
					<label
						htmlFor={id}
						className="form-check-label"
						aria-label={viewLabel}
					/>
				</div>
			</CardColumn>
			<CardColumn
				className="view-modal-card__title"
				width={
					description !== undefined && description !== ""
						? "xl"
						: "fill"
				}>
				{viewLabel}
			</CardColumn>
			{description !== undefined && description !== "" && (
				<CardColumn className="view-modal-card__desc" width="fill">
					{description}
				</CardColumn>
			)}
		</>
	);
}

export default ViewCard;
